import { InboxFilterForm } from '../../model/inbox-form-filter.model';
import { InvalidDataOrderStateModel } from '../../model/invalid-data-order-state.model';

export class InboxStateModel {
	inboxFilterForm?: InboxFilterForm;
	selectedOrderRow?: number;
	invalidDataOrder?: InvalidDataOrderStateModel;

	constructor() {
		this.inboxFilterForm = new InboxFilterForm();
		this.selectedOrderRow = undefined;
	}
}
